import { Button, CircularProgress, Typography } from '@material-ui/core'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import useStyles from './styles/userFooter.styles'

interface UserFooterProps {
  isSubmitting: boolean
  loadingForUser: boolean
}

export const UserFooter: React.FC<UserFooterProps> = ({
  isSubmitting,
  loadingForUser
}) => {
  const classes = useStyles()

  const hasnAccessToAddNewUser = getRoleFromStorage() === 'Admin'

  return (
    <div className={classes.root}>
      <Button variant="text">
        <Typography className={classes.redText}>
          {getTranslate('Cancel')}
        </Typography>
      </Button>
      <Button
        className={classes.saveButton}
        disabled={isSubmitting || !hasnAccessToAddNewUser || loadingForUser}
        variant="contained"
        color="primary"
        type="submit"
        size="medium">
        <Typography className={classes.whiteText}>
          {getTranslate('Save Changes')}
          {loadingForUser && (
            <CircularProgress className={classes.circularProgress} size={16} />
          )}
        </Typography>
      </Button>
    </div>
  )
}
